import React, { useEffect, useState } from 'react';
import CreditApplicationsMonitorTable from './CreditApplicationsMonitorTable';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { getSupplierCreditApplicationsMonitor } from '../../../../redux/services/creditApplicationsMonitorService';
import { AppInputField } from '../../../general/AppInputField/AppInputField';
import { Search } from 'react-feather';

import { CreditApplicationMonitor } from '@dill/dill-shared/dist/src';
import moment from 'moment';
import { AppButton } from '../../../general/AppButton/AppButton';
import { useNavigate } from 'react-router-dom';
import CreditMonitoringApp from './CreditMonitoringApp';
import PortfolioConnector from '../CreditMonitoringPortfolio/CreditMonitoringPortfolioTable';
import AutomatedCreditReviewTriggers from './AutomatedCreditReviewTriggers';
import { APP_ENVIRONMENT } from '../../../../utils/constants';

type Tab = 'creditMonitoring' | 'creditPortfolio' | 'reviewTriggers';

const TABS: { id: Tab; label: string }[] = [
  { id: 'creditMonitoring', label: 'Customers' },
  { id: 'creditPortfolio', label: 'Credit Portfolio' },
  // Demo concept, not wired to a backend yet - see AutomatedCreditReviewTriggers.tsx.
  ...(APP_ENVIRONMENT !== 'production'
    ? [{ id: 'reviewTriggers' as Tab, label: 'Review Triggers' }]
    : []),
];

const CreditApplicationsMonitor = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchText, setSearchText] = useState('');
  const [activeTab, setActiveTab] = useState<Tab>('creditMonitoring');
  const [searchedCreditApplicationsMonitor, setSearchedCreditApplicationsMonitor] = useState<
    CreditApplicationMonitor[]
  >([]);

  const { creditApplicationsMonitor } = useAppSelector((state) => state.creditApplicationsMonitor);

  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  useEffect(() => {
    if (!currentSupplier?.id) return;
    dispatch(getSupplierCreditApplicationsMonitor({ supplierId: currentSupplier?.id ?? '' }));
  }, [currentSupplier?.id]);

  useEffect(() => {
    if (creditApplicationsMonitor || searchText) {
      const creditApplicationsMonitorCopy = creditApplicationsMonitor;
      const searched = creditApplicationsMonitorCopy.filter((creditApplicationMonitor) => {
        const level = `${
          creditApplicationMonitor?.nacmReport?.CmsCRScoreDetail?.ClassType ?? 'Risk N/A'
        }`;
        const lastDetected = moment(creditApplicationMonitor.createdAt).format('MM/DD/YYYY');
        if (
          creditApplicationMonitor.companyName
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          // creditApplicationMonitor.address
          //   .toString()
          //   .toLowerCase()
          //   .includes(searchText.toLowerCase()) ||
          // creditApplicationMonitor.city
          //   .toString()
          //   .toLowerCase()
          //   .includes(searchText.toLowerCase()) ||
          // creditApplicationMonitor.state
          //   .toString()
          //   .toLowerCase()
          //   .includes(searchText.toLowerCase()) ||
          // creditApplicationMonitor.zip
          //   .toString()
          //   .toLowerCase()
          //   .includes(searchText.toLowerCase()) ||
          lastDetected.toString().toLowerCase().includes(searchText.toLowerCase()) ||
          creditApplicationMonitor.amount
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          (creditApplicationMonitor?.nacmReport?.CmsCRScoreDetail?.Score ?? 'N/A')
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          level.toString().toLowerCase().includes(searchText.toLowerCase())
        ) {
          return true;
        }
        return false;
      });
      setSearchedCreditApplicationsMonitor(searched);
    }
  }, [creditApplicationsMonitor, searchText]);

  return (
    <div className="flex flex-col w-full h-full ">
      {/* Tab bar */}
      <div className="sticky px-4 top-0 bg-white z-30 border-b border-gray-200">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors cursor-pointer bg-transparent ${
              activeTab === tab.id
                ? 'border-blue-600 text-blue-600 bg-white'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}>
            {tab.label}
          </button>
        ))}
      </div>
      <div className="flex flex-col w-full h-full p-4 overflow-scroll">
        {activeTab === 'creditMonitoring' && <CreditMonitoringApp />}
        {activeTab === 'creditPortfolio' && <PortfolioConnector />}
        {activeTab === 'reviewTriggers' && <AutomatedCreditReviewTriggers />}
      </div>
    </div>
  );
};

export default CreditApplicationsMonitor;
